<template>
  <div class="logistics boxs" v-if="order_base">
    <div class="tit">物流跟踪</div>

    <!-- 物流信息 -->
    <div class="infoStep empty">
    </div>

  </div>
</template>

<script>

  export default {
    name: "logistics",
    props: {
      orderItem: {
        required: true,
        type: Object,
      }
    },
    data() {
      return {
        order_base: this.orderItem,
        traces: [],
        ops: {
            scrollPanel: {
                padding: true
            },
            rail: {
                background: '#fff',
                opacity: 1,
                gutterOfSide: 0,
                size: '8px'
            },
            bar: {
                keepShow: true,
                background: '#ddd',
                size: '5px'
            },
        },//滚动条配置
      }
    },
    watch: {
      orderItem(val) {
        this.order_base = val
      }
    }
  }
</script>

<style scoped>
  .logistics {
    width: 38%;
    height: 300px;
    background: #fff;
    padding-top: 16px;
  }

  .logistics .tit {
    font-size: 13px;
    color: #333;
    text-indent: 14px;
    font-weight: bold;
  }


  .infoStep {
    width: 95%;
    height: 172px;
    margin: 10px auto 0;
  }

  /* 物流信息-空-图片 */
  .infoStep.empty {
    /* background: url("../../../assets/empty.png") no-repeat center center; */
    background: url("../../../../../../assets/images/order/empty.png") no-repeat center center;
    background-size: 84px 105px;
  }


</style>
